import React from "react";
import { redirect } from "react-router-dom";
import Career from "../../componentLayer/pages/career/Career.jsx";
import Description from "../../componentLayer/pages/career/Description.jsx";
import BdeTeam from "../../componentLayer/pages/career/bde-team/BdeTeam.jsx";
import Program from "../../componentLayer/pages/career/tech-team/Program.jsx";
import Bootcamp from "../../componentLayer/pages/career/Bootcamp.jsx";
import SkillAccelerator from "../../componentLayer/pages/career/skill-accelerator/SkillAccelerator.jsx";
import OpenPositions from "../../componentLayer/pages/career/open-positions/OpenPositions.jsx";
import JobDescription from "../../componentLayer/pages/career/open-positions/JobDescription.jsx";
import LifeAtKapilTech from "../../componentLayer/pages/career/life-at-kapiltech/LifeAtKapilTech.jsx";

export const CareerRouter = [
  // {
  //   path: "job-connecter-bootcamp",
  //   children: [
  //     { index: true, element: <Career /> },
  //     { path: "position_description/:id", element: <Description /> },
  //   ],
  // },
  {
    path: "open-positions",
    element: <OpenPositions />,
  },
  {
    path: "open-positions/:id",
    element: <JobDescription />,
  },
  {
    path: "job-connecter-bootcamp",
    element: <Program />,
  },
  {
    path: "infor-cloud-suite-bootcamp/apply",
    element: <Bootcamp />,
  },
  {
    path: "skill-accelerator-bootcamp",
    element: <SkillAccelerator />,
  },

  // {
  //   path: "bde-team",
  //   element: <BdeTeam />,
  // },
  {
    path: "life-at-kapiltech",
    element: <LifeAtKapilTech />,
  },
  {
    index: true,
    loader: () => redirect("/careers/open-positions"),
  },
];
